<template>
    <div class="card p-shadow-app">
        <NacexShippingTable />
    </div>
</template>

<script>
import NacexShippingTable from '@/components/shipment/NacexShippingTable.vue';

export default {
    name: 'ShipmentTracking',
    components: {
        NacexShippingTable
    },
    props: {
    },
    created() {

    },
    data() {
        return {

        };
    },
    methods: {
    }
}
</script>